import { Fragment, useEffect, useState } from "react";
import { isValidArray } from "../../../Layout/Common/common";

export const FamilyProductFeatureDetails = ({ items }) =>
  isValidArray(items) ? (
    <Fragment>
      <h6>Features</h6>
      <div className="proTech-details">
        {items.map((item, index) => (
          <div className="proTech-details-info" key={index}>
            <div className="specs-heading">
              <h5>{item.attributeName}</h5>
            </div>
            <div className="specs-details">
              <p
                dangerouslySetInnerHTML={{
                  __html: item.attributeValue,
                }}
              ></p>
            </div>
          </div>
        ))}
      </div>
    </Fragment>
  ) : null;

export const FamilyProductFeature = ({ params }) => {
  const [techData, setTechData] = useState(null);

  useEffect(() => {
    if (isValidArray(params)) setTechData(params);
  }, [params]);

  return (
    <Fragment>
      {techData && (
        <div className="row-product-features product-features">
          <FamilyProductFeatureDetails items={techData} />
        </div>
      )}
    </Fragment>
  );
};
